// extracted by mini-css-extract-plugin
module.exports = {"news":"styles_news__iMqyh","titleCont":"styles_titleCont__AfoBa","title":"styles_title__pazs_","icon":"styles_icon__SqldD","active":"styles_active__XNo6W"};